import * as Sentry from "@sentry/angular";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

import packageJson from '../package.json';
import { log } from "./app/shared/log";

if (environment.production) {
  Sentry.init({
    dsn: "https://fcfa7387580b2726217a9aa74ccfca18@o4506906665943040.ingest.us.sentry.io/4506918053216256",
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    environment: 'production',
    release: "oskaru-angular-frontend@" + packageJson.version,
  });
  enableProdMode();
}
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => log.error("bootstrapApplication() error", err));
